import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { ArrowLeft, ExternalLink, Star } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const Partners = () => {
 const { API } = useContext(AuthContext);
 const navigate = useNavigate();
 const [partners, setPartners] = useState([]);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
 fetchPartners();
 }, []);

 const fetchPartners = async () => {
 try {
 const response = await axios.get(`${API}/partners`);
 setPartners(response.data);
 } catch (error) {
 toast.error('Failed to load partners');
 } finally {
 setLoading(false);
 }
 };

 return (
 <div className="min-h-screen bg-background">
 <div className="bg-white shadow-sm border-b">
 <div className="container mx-auto px-4 py-4 flex items-center gap-4">
 <Button variant="ghost" onClick={() => navigate('/dashboard')} data-testid="back-btn">
 <ArrowLeft className="w-5 h-5" />
 </Button>
 <h1 className="text-2xl font-bold">Partner Network</h1>
 </div>
 </div>

 <div className="container mx-auto px-4 py-8">
 <Card className="mb-8 shadow-lg">
 <CardHeader>
 <CardTitle>Industry Partners & Associations</CardTitle>
 <CardDescription>
 Connect with freeze-drying associations, suppliers, and industry partners
 </CardDescription>
 </CardHeader>
 </Card>

 {loading ? (
 <div className="text-center py-12">
 <p className="text-slate-500">Loading partners...</p>
 </div>
 ) : partners.length === 0 ? (
 <Card className="text-center py-12">
 <CardContent>
 <p className="text-slate-500">No partners listed yet</p>
 </CardContent>
 </Card>
 ) : (
 <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
 {partners.map(partner => (
 <Card key={partner.id} className="shadow-lg card-hover" data-testid="partner-card">
 <CardHeader>
 <div className="flex items-start justify-between">
 <div className="flex-1">
 <CardTitle className="text-lg flex items-center gap-2">
 {partner.name}
 {partner.featured && <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" />}
 </CardTitle>
 {partner.region && (
 <p className="text-sm text-slate-500 mt-1">{partner.region}</p>
 )}
 </div>
 </div>
 </CardHeader>
 <CardContent>
 {partner.description && (
 <p className="text-sm text-slate-600 mb-4">{partner.description}</p>
 )}
 {partner.link && (
 <Button
 variant="outline"
 className="w-full"
 onClick={() => window.open(partner.link, '_blank')}
 data-testid="partner-link-btn"
 >
 Visit Website <ExternalLink className="w-4 h-4 ml-2" />
 </Button>
 )}
 </CardContent>
 </Card>
 ))}
 </div>
 )}
 </div>
 </div>
 );
};

export default Partners;
